import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: ''
    },
    getters: {
        token: state => state.token
    },

    mutations: {
        setToken: (state, payload) => state.token = payload
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js